module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"potential_duplicate_profile":"Potential Duplicate Profile","cancel":"Cancel","continue":"Continue"},"fr":{"potential_duplicate_profile":"Profil de doublon potentiel","cancel":"Annuler","continue":"Continuer"}}')
  delete Component.options._Ctor
}
